<template>
  <div id="base_information_outer" v-if="coachModel != null">
    <div class="input-row" id="name_view">
      <div class="column left-label">*姓名：</div>
      <div class="column">
        <el-input :class="[ (showRedBorder && !coachModel.name) ? 'red-border' : '']" v-model="coachModel.name" placeholder="请输入姓名" :disabled="!isAllowedEditIdNo" />
      </div>
    </div>

    <div class="input-row" id="photo_view">
      <div class="column left-label picuture-upload-label">*个人照片：</div>
      <div class="column">
        <el-upload :class="[ (showRedBorder && !coachModel.photo) ? 'red-border' : '', 'files-upload']" action="https://api.shslqxh.com/upload/files" :headers="uploadHeaders" name="files"
          :accept="acceptTypes" :show-file-list="false"
          :before-upload="handleUploadBefore"
          :on-error="handleUploadError"
          :on-success="handlePhotoUploadSuccess">
          <el-image v-if="coachModel.photo.length > 0" :src="coachModel.photo" class="avatar user-photo" />
          <i v-else class="el-icon-plus avatar-uploader-icon user-photo-plus"></i>
          <div slot="tip" class="el-upload__tip" style="margin-top: 15px;">必须为个人近期免冠证件照。</div>
        </el-upload>
      </div>
    </div>

    <div class="input-row" id="height_view">
      <div class="column left-label">*身高：</div>
      <div class="column">
        <el-input :class="[ (showRedBorder && !coachModel.height) ? 'red-border' : '']" v-model="coachModel.height" placeholder="请输入您的身高">
          <template slot="append">CM</template>
        </el-input>
      </div>
    </div>

    <div class="input-row" id="weight_view">
      <div class="column left-label">*体重：</div>
      <div class="column">
        <el-input :class="[ (showRedBorder && !coachModel.weight) ? 'red-border' : '']" v-model="coachModel.weight" placeholder="请输入您的体重">
          <template slot="append">KG</template>
        </el-input>
      </div>
    </div>

    <div class="input-row" id="area_view">
      <div class="column left-label">*所属区域：</div>
      <div class="column">
        <el-select :class="[ (showRedBorder && !coachModel.area) ? 'red-border' : '']" placeholder="请选择所属区域" v-model="coachModel.area">
          <el-option v-for="(item, index) in areaList" :key="'area_select_' + index" :label="item" :value="item" />
        </el-select>
      </div>
    </div>

    <div class="input-row" id="idNo_view">
      <div class="column left-label">*身份证号：</div>
      <div class="column">
        <el-input :class="[ (showRedBorder && !coachModel.idNo) ? 'red-border' : '']" v-model="coachModel.idNo" :disabled="!isAllowedEditIdNo" placeholder="请输入二代身份证号码"/>
      </div>
    </div>

    <div class="input-row" id="mobile_view">
      <div class="column left-label">*联系电话：</div>
      <div class="column">
        <el-input :class="[ (showRedBorder && !coachModel.mobile) ? 'red-border' : '']" v-model="coachModel.mobile" placeholder="请输入联系电话"/>
      </div>
    </div>

    <div class="input-row" id="unit_view">
      <div class="column left-label">*工作单位：</div>
      <div class="column">
        <el-input :class="[ (showRedBorder && !coachModel.unit) ? 'red-border' : '']" v-model="coachModel.unit"  placeholder="请输入您的工作单位"/>
      </div>
    </div>

    <div class="input-row" id="position_view">
      <div class="column left-label">*职位：</div>
      <div class="column">
        <el-input :class="[ (showRedBorder && !coachModel.position) ? 'red-border' : '']" v-model="coachModel.position" placeholder="请输入您的职位"/>
      </div>
    </div>

    <div class="input-row" id="political_view">
      <div class="column left-label">*政治面貌：</div>
      <div class="column">
        <el-select :class="[ (showRedBorder && !coachModel.political) ? 'red-border' : '']" placeholder="请选择您的政治面貌" v-model="coachModel.political">
          <el-option v-for="(item, index) in politicalList" :key="'political_select_' + index" :label="item" :value="item" />
        </el-select>
      </div>
    </div>

    <div class="input-row" id="education_view">
      <div class="column left-label">*最高学历：</div>
      <div class="column">
        <el-select :class="[ (showRedBorder && !coachModel.education) ? 'red-border' : '']" placeholder="请选择您的最高学历" v-model="coachModel.education">
          <el-option v-for="(item, index) in educationList" :key="'education_select_' + index" :label="item" :value="item" />
        </el-select>
      </div>
    </div>

    <div class="input-row" id="school_view">
      <div class="column left-label">*毕业院校：</div>
      <div class="column">
        <el-input :class="[ (showRedBorder && !coachModel.school) ? 'red-border' : '']" v-model="coachModel.school" placeholder="请输入您的毕业院校"/>
      </div>
    </div>

    <div class="input-row" id="strOutOfSchool_view">
      <div class="column left-label">*毕业时间：</div>
      <div class="column">
        <el-date-picker :class="[ (showRedBorder && !coachModel.strOutOfSchool) ? 'red-border' : '']" clearable v-model="coachModel.strOutOfSchool" :picker-options="pickerOptions" align="right" type="month"
          format="yyyy-MM" value-format="yyyy-MM" placeholder="请选择毕业时间">
        </el-date-picker>
      </div>
    </div>

    <div class="input-row" id="email_view">
      <div class="column left-label">*电子邮箱：</div>
      <div class="column">
        <el-input :class="[ (showRedBorder && !coachModel.email) ? 'red-border' : '']" v-model="coachModel.email" placeholder="请输入电子邮箱"></el-input>
      </div>
    </div>

    <div class="input-row" id="addr_view">
      <div class="column left-label">*邮寄地址：</div>
      <div class="column">
        <el-input :class="[ (showRedBorder && !coachModel.addr) ? 'red-border' : '']" v-model="coachModel.addr" placeholder="请输入邮寄地址" clearable></el-input>
      </div>
    </div>
    <el-button v-if="isAllField" class="bottom-button next-button" round @click="nextButtonClicked"> 下一步</el-button>
    <el-button v-else  class="bottom-button gray-button" round @click="noticeButtonClicked"> 下一步</el-button>

  </div>

</template>

<script>
  import DataCreator from "../../../../js/coach/data-creator.js";
  import EventManager from "../../../../js/event-common.js";
  import PictureTool from "../../../../js/picture-tool.js";
  import {Loading} from "element-ui";
  export default {
    name: "AddBaseInformationVue",
    props: {
      coach: {
        type: Object,
        default: null,
      }
    },
    data() {
      return {
        uploadHeaders: {},
        isAllowedEditIdNo: true,
        pickerOptions: {
          disabledDate: (time) => {
            return this.dealDisableDate(time);
          }
        },
        politicalList: [
          '党员',
          '民主党派',
          '团员',
          '群众'
        ],
        educationList: [
          '大专',
          '本科',
          '硕士',
          '博士'
        ],
        areaList: [
          '黄浦区',
          '静安区',
          '长宁区',
          '普陀区',
          '虹口区',
          '杨浦区',
          '浦东新区',
          '闵行区',
          '徐汇区',
          '宝山区',
          '嘉定区',
          '金山区',
          '松江区',
          '青浦区',
          '奉贤区',
          '崇明区',
          '学生体协',
          '上海体院',
          '其他行业体协'
        ],
        coachModel: null,
        initialData: null,
        isAllField: false,
        isEdited: false,
        showRedBorder: false,
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },

      httpManager() {
        return this.$store.state.http;
      },

      eventManager() {
        return this.$store.state.eventManager;
      },

      certId() {
        return this.$route.params.certId;
      },

      acceptTypes() {
        return PictureTool.acceptTypes;
      },
    },

    watch: {
      coachModel: {
        handler(val, oldVal) {
          this.isAllField = this.isDataAllFilled();
          console.log('---1 coach model');
          this.isDataEidted();
        },
        deep: true
      },
    },

    mounted() {
      console.log('---11');
      this.uploadHeaders.token = this.$store.state.dataStore.getToken();
      this.initData();
    },
    methods: {
      initData() {
        let user = this.user;
        if (user == null) {
          let _this = this;
          setTimeout(function() {
            _this.initData();
          }, 100);
          return;
        }

        let coach = this.coach;
        let coachModel = null;
        if (coach == null) {
          coachModel = DataCreator.methods.coach.getEmptyItem();
          coachModel.userId = user.id;
        } else {
          coachModel = coach;
          if (coachModel.auditTime != null && coachModel.auditStatus == 0 && coachModel.status == 7) {
            coachModel.id = 0;
          }
        }

        console.log(user);
        let idNo = user.idNumber;
        if (idNo != null && idNo.length > 0) {
          coachModel.idNo = idNo;
        } else {
          idNo = '';
        }

        let name = user.nickname;
        if (name != null && name.length > 0) {
          coachModel.name = name;
        }

        if (user.isIdentification > 0 && idNo.isIdCard()) {
          this.isAllowedEditIdNo = false;
        }

        let model = DataCreator.methods.coach.getModelFromItem(coachModel);
        this.coachModel = model;
        let copiedModel = DataCreator.tools.deepCopy(model);
        this.initialData = copiedModel;
      },

      updateData() {
        let coachModel = DataCreator.methods.coach.getOneData();
        let model = DataCreator.methods.coach.getModelFromItem(coachModel);
        this.coachModel = model;
        let copiedModel = DataCreator.tools.deepCopy(model);
        this.initialData = copiedModel;
      },

      isDataAllFilled() {
        let allFilled = DataCreator.tools.isItemAllFilled(this.coachModel);
        return allFilled;
      },

      isDataEidted() {
        // console.log(this.coachModel);
        let isEdited = !DataCreator.tools.isDeepEqualed(this.coachModel, this.initialData);
        if (this.isEdited == isEdited) {
          return;
        }
        this.isEdited = isEdited;
        let allowedLeave = !this.$store.state.allowedLeave;
        if (allowedLeave != isEdited) {
          this.$store.commit('isAllowedLeave', !isEdited);
        }
      },

      dealDisableDate(time) {
        return new Date().getTime() - (new Date(time).getTime()) < 0;
      },

      handlePhotoUploadChanged(file, fileList) {
        console.log('changed -- begin');
        console.log(file);
        console.log('changed -- end');
      },
      handleUploadBefore(file) {
        this.showUploadLoadings();
      },

      handleUploadError(err, file, fileList) {
        this.hideUploadLoadings();
      },

      showUploadLoadings() {
        this.hideUploadLoadings();
        this.uploadLoadings = Loading.service({
          target: document.getElementById('photo_view'),
          fullscreen: true
        });
      },
      hideUploadLoadings() {
        if (this.uploadLoadings) {
          this.uploadLoadings.close();
          this.uploadLoadings = null;
        }
      },

      handlePhotoUploadSuccess(res, file) {
        this.hideUploadLoadings();
        if (typeof res == 'string') {
          let url = res;
          this.coachModel.photo = url;
        }
      },

		noticeButtonClicked() {
      let coachModel = this.coachModel;
      if (coachModel == null) {
        return null;
      }

      let unCheckedList = ['id'];
      for (let key in this.coachModel) {
        if (unCheckedList.indexOf(key) >= 0) {
          continue;
        }
        let value = this.coachModel[key];
        if (!value) {
          let viewId = key + '_view';
          this.showRedBorder = true;
          document.getElementById(viewId).scrollIntoView(true);
          break;
        }
      }
		},
      nextButtonClicked() {
        console.log('print -- begin');
        console.log(this.coachModel);
        console.log('print -- end');
        if (!this.isEdited && this.coachModel.id > 0) { // 未修改的话，不用上传数据
          this.$emit("next");
          return;
        }
        let params = {};
        for(let key in this.coachModel) {
          params[key] = this.coachModel[key];
        }
        let idNo = params.idNo.removeBlanks();
        if (idNo == '') {
          this.$toast('请输入二代身份证号码！');
          return;
        }
        if (idNo.length < 18 || !idNo.isIdCard()) {
          this.$toast("请输入正确的二代身份证号码！");
          return;
        }
        params.idNo = idNo;
        let sex = idNo.getSexFromIdCard();
        params.sex = sex;
        params.strOutOfSchool = this.$moment(params.strOutOfSchool).format('yyyy-MM-DD');
        params.status = 1;
        params.auditStatus = 1;
        console.log(params);

        let _this = this;
        let loadFlags = Loading.service({
          target: document.getElementById('app'),
          fullscreen: true
        });
        this.httpManager.ajax.postCoachEditRequest(params, function(data) {
          console.log(data);
          loadFlags.close();
          let code = data.code;
          if (code == 0) {
            console.log('coach updated success!');
            _this.eventManager.postNotification(EventManager.notificationNameObject.updateCoachData, null);
            _this.isEdited = false;
            _this.$store.commit('isAllowedLeave', true);
            return;
          }
          _this.$toast("保存失败！");
        }, function(data) {
          loadFlags.close();
          _this.$toast("保存失败，请重试！");
        });
      },

    }
  }
</script>

<style scoped>
  @import url("../../../../css/back-next-buttons.css");
  @import url("../../../../css/input-row.css");
  #base_information_outer {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
  }

  #base_information_outer .user-photo-plus {
    width: 140px;
    height: 140px;
    border: solid 1px lightgrey;
    line-height: 140px;
    text-align: center;
    font-size: 3rem;
    color: gray;
  }

  #base_information_outer .red-border .user-photo-plus {
    border-color: #fc1a34;
  }

  #base_information_outer .user-photo {
    max-width: 140px;
    max-height: 140px;
  }

  #base_information_outer .el-select {
    width: 100%;
  }

  #base_information_outer /deep/ .el-input__inner:focus,
  #base_information_outer /deep/ .el-textarea__inner:focus {
    border: solid 1px #fc1a34;
  }

  #base_information_outer /deep/ .el-radio .el-radio__input .el-radio__inner:hover {
    border-color: #fc1a34;
  }

  #base_information_outer /deep/ .el-radio.is-checked .el-radio__input .el-radio__inner {
    border-color: #fc1a34;
    background-color: #fc1a34;
  }

  #base_information_outer /deep/ .el-radio.is-checked .el-radio__label {
    color: #fc1a34;
  }


  #base_information_outer .bottom-button {
    width: 90%;
    max-width: 300px;
    margin-top: 30px;
  }

  #base_information_outer .gray-button {
	  width: 90%;
	  max-width: 300px;
	  margin-top: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/personal/coachApplications/children/AddBaseInformation.vue